<template>
<div>
    <slot v-if="authenticated"></slot>
</div>
</template>

<script>

export default {
    data: () => ({
    }),
    computed: {
        authenticated() {
            return this.$store.state.token !== null;
        },
    },
    mounted() {
        if (!this.authenticated) {
            this.$router.push({name: 'home'});
        }
    },
    methods:
    {
    },
};
</script>

<style>

</style>
